import { CommandsDirectory } from "@components/commands/lib";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { useCommands } from "@components/commands/useCommands";
import { Menu } from "@design-system/Menu/Menu.lib";
import { FC } from "react";

export const WorkspaceSwitcherItem: FC = () => {
    const { open: openCommands } = useCommands();

    return (
        <Menu.Item
            onClick={() => openCommands(CommandsDirectory.WORKSPACES)}
            rightText={<Shortcut keys="o>w" />}
        >
            Switch workspace
        </Menu.Item>
    );
};
